<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 1C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H13Z"
            fill="#3C67EA"
        />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 7L9 7L9 12H7L7 7Z" fill="white" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 4L9 4V6H7L7 4V4Z" fill="white" />
    </svg>
</template>
